// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c213f8e1","952":"bae27af8"}[chunkId] + ".chunk.js";
};